import React from "react";
import QRCode from "qrcode.react";

function QRCodeGenerator({ value, size }) {
  return (
    <div>
      <QRCode value={value} size={size} />
    </div>
  );
}

export default QRCodeGenerator;
